import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

const AuthContext = createContext();
let API = process.env.REACT_APP_API_URL || 'http://localhost:7381/api/v1/';
if (API && !API.includes('/api/v1')) {
  API = API.endsWith('/') ? `${API}api/v1/` : `${API}/api/v1/`;
}

// Set once outside component
axios.defaults.baseURL = API;

axios.interceptors.request.use(config => {
  const token = localStorage.getItem('esxToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
}, error => Promise.reject(error));

axios.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('esxToken');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('esxToken');
    if (token) {
      axios.get('/auth/me')
        .then(res => setUser(res.data.user))
        .catch(() => localStorage.removeItem('esxToken'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
    return undefined;
  }, []);

  const login = async (email, password) => {
    const res = await axios.post('/auth/login', { email, password });
    localStorage.setItem('esxToken', res.data.token);
    setUser(res.data.user);
    return res.data.user;
  };

  const register = async (data) => {
    const res = await axios.post('/auth/register', data);
    localStorage.setItem('esxToken', res.data.token);
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = () => {
    localStorage.removeItem('esxToken');
    setUser(null);
    toast.success('Logged out successfully');
  };

  const updateUser = async (data) => {
    const res = await axios.put('/auth/update-profile', data);
    setUser(res.data.user);
    return res.data.user;
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export default AuthContext;
